var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"main-container"}},[_c('div',{staticClass:"content"},[_c('vue-table',{attrs:{"path":_vm.initTableURL,"i18n":_vm.i18n}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }